import * as React from "react";
import { RouteComponentProps } from "@reach/router";
import { Calendar } from "../calendar/Calendar";

export class CalendarScreen extends React.PureComponent<RouteComponentProps> {
  render() {
    return <Calendar />;
  }
}
